"use strict";

exports.__esModule = true;
exports.default = void 0;
var _propTypes = require("prop-types");
var _reactEmotion = _interopRequireDefault(require("react-emotion"));
var _base = _interopRequireDefault(require("../../shared/base"));
var _font = _interopRequireDefault(require("../../shared/font"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Card = /*#__PURE__*/
(0, _reactEmotion.default)('a', {
  target: "e1m7av400"
})(_base.default, ";", _font.default, ";font-family:", function (props) {
  return props.font ? props.font : "'Inter', sans-serif";
}, ";display:block;height:auto;padding:", function (props) {
  return props.big ? '60px 45px 32px' : '32px 45px';
}, ";border-radius:2px;box-shadow:0 2px 4px 0 rgba(0,0,0,0.05);background-color:", function (props) {
  return props.theme === 'dark' ? '#2a3644' : '#fff';
}, ";text-align:center;color:", function (props) {
  return props.theme === 'dark' ? '#dfdfdf' : '#424242';
}, ";text-decoration:none;cursor:", function (props) {
  return props.href ? 'pointer' : 'default';
}, ";h4{color:", function (props) {
  return props.theme === 'dark' ? '#dfdfdf' : '#424242';
}, ";transition:all 0.3s ease;}img{height:120px;margin-bottom:12px;}p{font-size:14px;width:100%;max-width:200px;margin:0 auto 20px;}&:hover,&:focus{h4{color:", function (props) {
  return props.href ? props.theme.primaryColor || props.theme === 'dark' ? 'rgb(136 154 225)' : 'blue' : '#424242';
}, ";}}");
Card.defaultProps = {
  theme: 'light'
};
Card.propTypes = {
  theme: _propTypes.string
};
var _default = Card;
exports.default = _default;